export enum STAND_WORKSHEET_STATUS_VALUE {
  Open = 'open',
  Approved = 'approved',
  Completed = 'completed',
  Canceled = 'canceled',
}

export enum EVENT_STATUS_VALUE {
  Open = 'open',
  Closed = 'closed',
  Pending = 'pending',
  Canceled = 'canceled',
  Completed = 'completed',
}
